import { Gathering } from '../../../../../../modules/API/Gathering/gathering';
import { BARKODE_TYPE, IResponseSrikaNode } from '../../../../../../modules/API/Gathering/models/srika';

/**
 * Service for barcode scanning operations
 */
class BarcodeScannerService {
  /**
   * Get entry data by barcode
   * Supports both permanent codes (with '#' prefix) and regular barcodes
   * 
   * @param barcode - The barcode string to scan
   * @returns Promise with entry data
   * @throws Error if barcode not found
   */
  static async getEntryByBarcode(barcode: string): Promise<IResponseSrikaNode> {
    if (!barcode || !barcode.trim()) {
      throw new Error('Barcode cannot be empty');
    }

    const permanentCode = barcode.split('#');
    
    if (permanentCode.length > 1) {
      return await Gathering.getPermanentKnisaByBarcode(permanentCode[1]);
    }
    
    return await Gathering.getKnisaByBarcode(barcode);
  }

  /**
   * Get list of all pallet barcodes
   * 
   * @returns Promise with list of barcode entries
   * @throws Error if request fails
   */
  static async getBarcodeList(): Promise<IResponseSrikaNode> {
    return await Gathering.getKnisot(BARKODE_TYPE.PALLET);
  }

  /**
   * Validate if barcode has correct format
   * 
   * @param barcode - The barcode string to validate
   * @returns true if barcode format is valid
   */
  static isValidBarcodeFormat(barcode: string): boolean {
    if (!barcode || typeof barcode !== 'string') {
      return false;
    }

    const trimmed = barcode.trim();
    return trimmed.length > 0;
  }

  /**
   * Parse permanent code from barcode
   * 
   * @param barcode - The barcode string (may contain '#' prefix)
   * @returns The actual code without prefix
   */
  static parseBarcodeCode(barcode: string): string {
    const parts = barcode.split('#');
    return parts.length > 1 ? parts[1] : barcode;
  }
}

export default BarcodeScannerService;

